export enum HonorariumPreLiquidationStatusId {
    ACTIVE    = 1,
    COMPLETED = 2,
    CANCELLED = 3,
}

export enum HonorariumPreLiquidationItemStatusId {
    PENDING    = 1,
    LIQUIDATED = 2,
}

/** Código del tipo de detalle (`type` de HonorariumPreLiquidationDetailDTO). Solo los honorarios se pueden eliminar. */
export enum HonorariumPreLiquidationDetailTypeCode {
    HONORARIO = 'HONORARIO',
    ANTICIPO  = 'ANTICIPO',
}

export enum HonorariumDetailSourceTypeId {
    PATIENT  = 1,
    FINANCER = 2,
}

export interface HonorariumPreLiquidationDTO {
    honorariumPreLiquidation: number;
    professional: number;
    professionalName: string;
    billingEntity: number;
    billingEntityName: string;
    site: number;
    createdDatetime: string;
    status: string;
    statusId: number;
    totalProfessionalAmount: number;
    pendingItemCount: number;
    liquidatedItemCount: number;
}

/** Filtros del historial; los vacíos no se mandan. */
export interface PreLiquidationFilters {
    /** Código de estado: ACTIVE o COMPLETED (las canceladas no se listan). */
    status?: string;
    billingEntityId?: number;
    professionalId?: number;
}

export interface DeletePreLiqDetailResultDTO {
    /** El ítem se quedó sin detalles de honorario y se eliminó. */
    itemRemoved: boolean;
    /** La pre-liquidación se quedó sin ítems y se canceló: para el usuario, se eliminó. */
    preLiquidationCancelled: boolean;
}

export interface HonorariumPreLiquidationItemDTO {
    honorariumPreLiquidationItem: number;
    honorariumPreLiquidation: number;
    professional: number;
    professionalName: string;
    billingEntity: number;
    billingEntityName: string;
    sourceType: string;
    sourceTypeId: number;
    fromDate: string;
    toDate: string;
    totalAmount: number;
    professionalAmount: number;
    status: string;
    statusId: number;
    detailCount: number;
}

export interface HonorariumPendingProfessionalSummaryDTO {
    professional: number;
    professionalName: string;
    billingEntity: number;
    billingEntityName: string;
    itemCount: number;
    preLiqCount: number;
    professionalAmount: number;
}

export interface HonorariumPreLiquidationDetailDTO {
    honorariumPreLiquidationDetail: number;
    honorariumPreLiquidationItem: number;
    administrativeForm: number | null;
    benefitOrder: number | null;
    amount: number;
    honorariumPercentage: number | null;
    professionalAmount: number;
    description: string;
    type?: string | null;
    date?: string | null;
    /** Orden, débito/crédito, anulación…; null en pre-liquidaciones anteriores a los movimientos. */
    movementType: string | null;
    patientName: string | null;
    /** Lo que el tipo de movimiento no dice: NC o ND, crédito/débito de prefactura o la causa de la corrección. */
    movementDetail: string | null;
    /** Quién paga la orden: "Paciente" o "Financiador". */
    payerTypeName: string | null;
    /** Práctica: el nomenclador de la prestación. */
    nomenclatorDescription: string | null;
}

export interface CreateFinancerPreLiquidationRequestDTO {
    billingEntityId: number;
    fromDate: string;
    toDate: string;
    healthEntityId?: number | null;
    professionalIds?: number[] | null;
    formStateTypes?: number[];
    benefitOrderStates?: number[];
    paymentMethodIds?: number[];
    /** Quién paga la orden (EPayerType); vacío = todos. */
    payerTypes?: number[];
}
